<template>
	<v-container class="main" fluid fill-width>
		<Alert v-model="errorTitle">{{ errorDetail }}</Alert>
		<loading :active.sync="loading" :is-full-page="true" color="#4caf50"></loading>

		<!-- toolbar -->
		<div class="toolbar">
			<v-row align="center">
				<v-text-field outlined dense clearable hide-details height="48"
					prepend-inner-icon="mdi-magnify"
					placeholder='Search'
					style="padding-right:10px"
					v-model="searchString"
					@keyup.enter="search()"
					@click:clear="clearSearch()">
				</v-text-field>
				<v-btn class="btn" small elevation="0" @click="showNewServiceType()">
					<v-icon>mdi-plus-circle</v-icon>
					<span class="d-none d-md-inline">Add Service Type</span>
				</v-btn>
			</v-row>
		</div>

		<v-card class="tableCard" style="margin-top:10px">
			<v-data-table fixed-header hide-default-footer
				v-model="selected"
				:headers="headers"
				:items="serviceTypes"
				:items-per-page="limit"
				:mobile-breakpoint="700"
				item-key="name"
				class="elevation-0"
				style="border-radius: 0"
				@click:row="showServiceTypeDetail"
				>

				<template v-slot:item.icon="{ item }">
					<div class="d-flex align-center img-container pointer" style="height:32px;width:32px;border-radius:5px" :style="{'background':item.fields.color.de + ' !important'}">
						<v-img style="opacity:0.25;width:75%;height:75%;margin:auto;" contain :src="getAssetUrl(item.fields.icon.de)"/>
					</div>
				</template>
				<template v-slot:item.title="{ item }">
					{{ item.fields.title.en }}
				</template>
				<template v-slot:item.updated_at="{ item }">
					{{ item.sys.updatedAt | formatDate }}
				</template>
				<template v-slot:item.status="{ item }">
					<Status :status="item.fields.status" />
				</template>
			</v-data-table>

			<v-card class="tableFooter">
				<v-card-actions>
					<TablePaginator v-model="offset" :limit="limit" :total="count" @input="getServiceTypes()" :results="serviceTypes" />
				</v-card-actions>
			</v-card>
		</v-card>

	</v-container>
</template>

<script>
import Loading from 'vue-loading-overlay'
import Alert from '@/components/common/Alert.vue'
import TablePaginator from '@/components/common/TablePaginator.vue'
import Status from '@/components/common/Status.vue'
import Common from '@/mixins/Common.vue'

export default {
	name: 'ServiceTypesView',
	components: { Loading, Alert, TablePaginator, Status },
	mixins: [ Common ],

	data() {
		return {
			searchString: '',

			offset: this.$store.state.offset,
			limit: 15,
			
			serviceTypes: [],
			count: 0,
			selected: []
		}
	},

	computed: {
		headers () {
			return [
				{ text: '', value: 'icon', sortable: false, width: '40px' },
				{ text: 'Service Type Name', value: "title", sortable: false },
				{ text: 'Updated At', value: "updated_at", sortable: false,  width: '15%' },
				{ text: 'Status', value: "status", sortable: false, align: 'center', width: '15%' },
			]
		},
	},

	mounted() {
		this.getServiceTypes()
	},

	methods: {
		async getServiceTypes() {
			this.loading = true
			try {
				await this.$store.commit('setOffset', this.offset)
				let url = `/service-types?skip=${this.offset}&limit=${this.limit}&include=1&searchString=${encodeURIComponent(this.searchString)}`
				
				const res = await this.$httpGet(url)
				this.serviceTypes = res.serviceTypes
				this.count = res.total
			}
			catch (error) {
				this.showError(error)
			}
			this.loading = false
		},
		async showServiceTypeDetail(item) {
			try {
				this.loading = true
				const serviceType = await this.$httpGet(`/service-type/${item.sys.id}`)
				await this.$store.commit('setSelectedServiceType', serviceType)
				this.loading = false

				this.$router.push('/servicetype-detail')
				
			} catch (error) {
				this.showError(error)
			}
		},
		async showNewServiceType() {
			await this.$store.commit('setSelectedServiceType', null)
			this.$router.push('/servicetype-detail')
		},
		async search() {
			await this.$store.commit('setSearchString', this.searchString)
			
			if (this.searchString?.length > 0) {
				this.offset = 0
				this.getServiceTypes()
			} else {
				this.clearSearch()
			}
		},
		async clearSearch() {
			this.searchString = '', this.offset = 0
			await this.$store.commit('setSearchString', '')
			
			await this.getServiceTypes()
		}
	}
}
</script>

